import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { ErrorLogComponent } from '@cian/error-log-component';

export const initializeGeoSwitcher = async () => {
  const config = getConfig();
  const geoSwitcher = config.get<boolean>('geoSwitcher');

  if (!geoSwitcher) {
    return;
  }

  const logger = getLogger();

  const { GeoSwitcher } = await import('../../containers/geo_switcher');
  const newHeaderEnabled = !!config.get<boolean>('newHeaderEnabled');
  const geoSwitcherPopup = !!config.get<boolean>('geoSwitcherPopup');

  const container = document.getElementById('header_geo_switcher');

  ReactDOM.render(
    <ErrorLogComponent logger={logger}>
      <GeoSwitcher newHeaderEnabled={newHeaderEnabled} geoSwitcherPopup={geoSwitcherPopup} />
    </ErrorLogComponent>,
    container,
  );

  setTimeout(() => {
    if (container && newHeaderEnabled) {
      // dirty-hack init another change location
      const callGeoSwitcher = () => {
        const geoSwitcherLink: HTMLElement | null = document.querySelector('#header_geo_switcher a');
        if (geoSwitcherLink) {
          geoSwitcherLink.click();
        }
      };
      const anotherContainers = document.getElementsByClassName('another-change-location');

      for (let i = 0; i < anotherContainers.length; i++) {
        anotherContainers[i].innerHTML = container.innerHTML;
        anotherContainers[i].addEventListener('click', callGeoSwitcher);
      }
    }
  }, 500);
};
